import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, RefrigeratorIcon, BlindsIcon, ShirtIcon, WashingMachineIcon, WarehouseIcon, type LucideIcon } from 'lucide-react';
interface AddOn {
  icon: LucideIcon;
  label: string;
}
const ADDONS: AddOn[] = [{
  icon: FlameIcon,
  label: 'Oven'
}, {
  icon: RefrigeratorIcon,
  label: 'Fridge'
}, {
  icon: BlindsIcon,
  label: 'Window Interiors'
}, {
  icon: ShirtIcon,
  label: 'Closet Organization'
}, {
  icon: WashingMachineIcon,
  label: 'Laundry'
}, {
  icon: WarehouseIcon,
  label: 'Basement Cleaning'
}];
export function ExtraServices() {
  return <section className="w-full bg-sky-softbg" data-id="element-54" data-mp="1lncncguz99zc">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24" data-id="element-55" data-mp="1lonr4gofahqg">
        <div className="mx-auto max-w-2xl text-center" data-id="element-56" data-mp="3sdkcmcak9ehm">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-brand" data-id="element-57" data-mp="3se2dxnc2yiwe">
            Add-ons
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-58" data-mp="19t51kyuzl7jx">
            Tailor Your Experience
          </h2>
          <p className="mt-4 text-slate-soft" data-id="element-59" data-mp="1esra4uzvdzme">
            Customize any visit with the extra touches that matter most to you.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-id="element-60" data-mp="1nl30yhywbp2w">
          {ADDONS.map(({
          icon: Icon,
          label
        }, i) => <motion.div key={label} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="group flex flex-col items-center gap-3 rounded-2xl bg-white p-6 text-center shadow-[0_2px_16px_rgba(15,23,42,0.04)] ring-1 ring-slate-100 transition-all hover:-translate-y-1 hover:ring-sky-brand" data-id="element-61" data-mp="1sj4i2xcrhebq" data-mpi={i}>
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sky-softbg text-slate transition-colors group-hover:bg-sky-brand group-hover:text-white" data-id="element-62" data-mp="1aiikn15sw5zo">
                <Icon className="h-5 w-5" strokeWidth={1.8} data-id="element-63" data-mp="1kf53jkekgmz2" />
              </span>
              <span className="text-sm font-medium text-slate-soft" data-id="element-64" data-mp="1yewbb3ehp74m">
                {label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}